import { ref, getCurrentInstance } from 'vue';
import { useStockVO } from '@rebuild/hooks/useStockVO';
import { useModuleData } from '@rebuild/hooks/data/useModuleData';
import { EN } from '@/locales';

/**
 * 股票表格 Tab 逻辑 Hook
 * 用于管理分红计划、融资融券、南北向资金等表格 Tab 的数据和状态
 */
export function useStockTableTabs() {
	const { proxy } = getCurrentInstance();
	const { isHKStock } = useStockVO();
	const { quote_stockDividendPlan, quote_stockMarginFunds, quote_stockNorthSouthFunds } = useModuleData();

	// Tab 相关状态
	const tabActValue = ref('');
	const otherDataTabList = ref([]);

	// 切换 Tab
	const changeTableTab = result => {
		tabActValue.value = result.value;
	};

	// 查询分红计划
	const queryDividendPlan = async () => {
		await quote_stockDividendPlan.refresh();
		return {
			label: proxy.$t('enterprise.dividends'),
			prop: 'dividendPlan',
			data: quote_stockDividendPlan.data.data || []
		};
	};

	// 查询融资融券
	const queryMarginFunds = async () => {
		await quote_stockMarginFunds.refresh({
			pageStart: 0,
			pageNum: 20
		});
		return {
			label: '融资融券',
			prop: 'marginFunds',
			data: quote_stockMarginFunds.data.data || [],
			total: quote_stockMarginFunds.data.total || 0
		};
	};

	// 查询南北向资金
	const queryMorthSouthFunds = async () => {
		const composeLabel = isHKStock.value
			? proxy.$t('enterprise.southbound-capital')
			: proxy.$t('enterprise.northbound-funds');

		await quote_stockNorthSouthFunds.refresh({
			pageStart: 0,
			pageNum: 20
		});
		return {
			label: composeLabel,
			prop: 'northSouthFunds',
			data: quote_stockNorthSouthFunds.data.data || [],
			total: quote_stockNorthSouthFunds.data.total || 0
		};
	};

	// 刷新 Tab 数据
	const refreshTabData = () => {
		Promise.all([queryDividendPlan(), queryMarginFunds(), queryMorthSouthFunds()]).then(queryRes => {
			let filterRes = queryRes.filter(item => item.data && item.data.length);
			// 英文版本的融资融券暂不展示
			if (proxy.$i18n.locale == EN) {
				filterRes = filterRes.filter(item => item.prop !== 'marginFunds');
			}
			otherDataTabList.value = filterRes.map(item => {
				return {
					label: item.label,
					value: item.prop
				};
			});
			if (otherDataTabList.value.length) {
				// 默认选中第一个
				tabActValue.value = otherDataTabList.value[0].value;
			}
		});
	};

	return {
		tabActValue,
		otherDataTabList,
		changeTableTab,
		refreshTabData
	};
}

